/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shorts links (youtube.com/shorts/<video-id>) work exactly like regular watch URLs — paste one in and the tool reads the same 11-character ID out of the /shorts/ path and fetches the same five thumbnail files (default, mqdefault, hqdefault, sddefault, maxresdefault) from YouTube's CDN.

The catch is that YouTube still generates those thumbnail files at the standard 16:9 ratio, even though a Short's video itself is vertical 9:16. That means the downloaded image is usually a horizontal crop or letterboxed version of a frame from the vertical video, not the full 9:16 frame viewers see scrolling through the Shorts feed.

If the auto-generated thumbnail doesn't show the frame you actually want, downloading it here won't fix that — it only pulls whatever frame YouTube already picked. For a specific vertical frame, scrub to that moment in the video itself and take a screenshot, or use YouTube's own thumbnail/cover picker when uploading a Short.`)
};

const es_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

const de_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

const nl_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

const fr_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

const it_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

const pt_br2_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

const pt_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

const ja_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

const zh_yt_shorts_howto = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Short, copy its link (it looks like youtube.com/shorts/VIDEO_ID), and paste it above. Every available thumbnail size appears for download or copy.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_shorts_howto = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_shorts_howto(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_shorts_howto", locale)
	if (locale === "en") return en_yt_shorts_howto(inputs)
	if (locale === "es") return es_yt_shorts_howto(inputs)
	if (locale === "de") return de_yt_shorts_howto(inputs)
	if (locale === "nl") return nl_yt_shorts_howto(inputs)
	if (locale === "fr") return fr_yt_shorts_howto(inputs)
	if (locale === "it") return it_yt_shorts_howto(inputs)
	if (locale === "pt-BR") return pt_br2_yt_shorts_howto(inputs)
	if (locale === "pt") return pt_yt_shorts_howto(inputs)
	if (locale === "ja") return ja_yt_shorts_howto(inputs)
	return zh_yt_shorts_howto(inputs)
};